<div class="flex flex-col w-full h-full">
  <h1 class="mb-8 text-light-300 text-3xl font-medium">
    {{ showBookmarkedProperties ? "Bookmarks" : "Properties" }}
    <span class="text-xl text-red-100">(Demo Mode)</span>
  </h1>

  @if(!showBookmarkedProperties && properties.length !== 0 ||
  (!showBookmarkedProperties && appliedFiltersCount > 0) ){
  <div class="flex flex-row gap-1 items-center mb-6 sm:gap-5">
    <div class="w-full lg:w-[475px] min-w-[280px]">
      <app-tablist
        [tabs]="tabs"
        [activeTab]="activeTab"
        (activeTabChange)="onActiveTabChange($event)"
      />
    </div>

    <p-button
      styleClass="bg-light-0! h-11 w-11 shadow! hover:bg-blue-200!"
      [rounded]="true"
      severity="secondary"
      [outlined]="true"
      [raised]="true"
      (onClick)="filterPopover.toggle($event)"
    >
      @if(appliedFiltersCount > 0){
      <div
        class="absolute top-1.5 right-1.5 flex items-center justify-center text-[10px] text-light-0 bg-light-300 rounded-full h-3.5 w-3.5"
      >
        {{ appliedFiltersCount }}
      </div>
      }
      <img src="assets/images/filter-48-forma-regular.png" />
    </p-button>

    <p-popover styleClass="dropdown-popover" #filterPopover>
      <div class="flex flex-col gap-4 w-fit sm:w-[25rem] bg-light-0">
        <div class="flex flex-row items-center justify-between h-[42px]">
          <h2 class="font-medium text-lg text-light-300">Filter properties</h2>

          @if (investementStrategyValues.length > 0 ||
          propertyStateValues.length > 0 || propertyCategoryValues.length > 0) {
          <p-button
            label="Reset"
            severity="secondary"
            [rounded]="true"
            (onClick)="resetFilters()"
          />
          }
        </div>

        <div class="flex flex-col gap-1 w-full">
          <label class="font-normal text-base text-light-200">
            Investment strategy
          </label>

          <p-multiselect
            [options]="investementStrategyOptions"
            optionLabel="name"
            [(ngModel)]="investementStrategyValues"
            placeholder="Select investment strategies"
            (onChange)="onInvestmentStrategyChange($event)"
          />
        </div>

        <div class="flex flex-col gap-1 w-full">
          <label class="font-normal text-base text-light-200">
            Property state
          </label>

          <p-multiselect
            [options]="propertyStateOptions"
            optionLabel="name"
            [(ngModel)]="propertyStateValues"
            placeholder="Select property state"
            (onChange)="onPropertyStateChange($event)"
          />
        </div>

        <div class="flex flex-col gap-1 w-full">
          <label class="font-normal text-base text-light-200">
            Property category
          </label>

          <p-multiselect
            [options]="propertyCategoryOptions"
            optionLabel="name"
            [(ngModel)]="propertyCategoryValues"
            placeholder="Select property category"
            (onChange)="onPropertyCategoryChange($event)"
          />
        </div>
      </div>
    </p-popover>
  </div>
  }

  <!-- <div class="grid grid-cols-[repeat(auto-fit,minmax(350px,1fr))] gap-10 pb-8"> -->
  <!-- <div
    class="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] sm:grid-cols-[repeat(auto-fit,minmax(350px,390px))] gap-10 pb-8 bg-amber-950 items-stretch"
  > -->

  <div
    class="grid grid-cols-1 gap-8 place-items-stretch justify-items-center w-auto md:justify-items-start lg:grid-cols-2 xl:grid-cols-3"
  >
    @for (property of properties; track $index) {
    <p-card
      class="w-fit"
      [style]="{
        'max-width': '390px',
        height: '100%',
        overflow: 'hidden',
        cursor: 'pointer',
      }"
      (click)="onPropertyView(property.$id)"
    >
      <ng-template #header>
        <div class="relative z-30" (click)="handleClick(property.$id, $event)">
          @if(property.investementStatus === InvestementStatus.EXITED){
          <div
            class="absolute top-0 left-0 z-10 flex items-center justify-center bg-blue-100 w-full h-8 font-bold text-sm text-light-0"
          >
            Sold
          </div>
          <!--  -->
          } @else {
          <div
            class="absolute top-3 left-3 z-10 flex flex-row items-center gap-1 rounded-4xl cursor-default py-1 px-3"
            [ngClass]="{
              'bg-orange-100':
                property.investmentStrategy?.type ===
                InvestmentStrategyTypeEnum.BALANCED,
              'bg-green-160':
                property.investmentStrategy?.type ===
                InvestmentStrategyTypeEnum.CAPITAL_GROWTH,
              'bg-purple-100':
                property.investmentStrategy?.type ===
                InvestmentStrategyTypeEnum.FIX_N_FLIP,
              'bg-blue-700':
                property.investmentStrategy?.type ===
                InvestmentStrategyTypeEnum.HIGH_YIELD,
              'bg-yellow-100':
                property.investmentStrategy?.type ===
                InvestmentStrategyTypeEnum.GOLDEN_VISA
            }"
          >
            <svg-icon
              [src]="
                'assets/icons/' + property.investmentStrategy?.type + '.svg'
              "
              svgClass="h-4 w-4"
            />

            <span class="font-semibold text-xs text-light-200">
              {{ property.investmentStrategy?.name }}

              <!-- @switch (property.investmentStrategy?.type) {
                @case (InvestmentStrategyTypeEnum.BALANCED) { Balanced }
                @case (InvestmentStrategyTypeEnum.CAPITAL_GROWTH) { Capital Growth
                }
                @case (InvestmentStrategyTypeEnum.FIX_N_FLIP) { Fix & Flip }
                @case (InvestmentStrategyTypeEnum.HIGH_YIELD) { High Yield }
                @case (InvestmentStrategyTypeEnum.GOLDEN_VISA) { Golden Visa }
                } -->
            </span>
          </div>
          }

          <p-carousel
            [value]="property.images"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="false"
            [showNavigators]="true"
            [showIndicators]="true"
            styleClass="seedio-carousel"
          >
            <ng-template let-item #item>
              <img
                [src]="item.url"
                loading="lazy"
                [alt]="item.caption"
                class="w-full rounded-border h-[232px]"
              />
            </ng-template>
          </p-carousel>
        </div>
      </ng-template>

      <div class="flex flex-row items-center h-[18px] mb-2 overflow-hidden">
        @if (property.category === categoryEnum.COMMERCIAL) {
        <div class="flex flex-row items-center gap-1">
          <span class="font-semibold text-xs text-light-200"> Commercial </span>
        </div>

        } @else if (property.category === categoryEnum.INDUSTRIAL) {
        <div class="flex flex-row items-center gap-1">
          <span class="font-semibold text-xs text-light-200"> Industrial </span>
        </div>

        } @else if (property.category === categoryEnum.ENERGY) {
        <div class="flex flex-row items-center gap-1">
          <span class="font-semibold text-xs text-light-200"> Energy </span>
        </div>

        } @else if (property.category === categoryEnum.LAND) {
        <div class="flex flex-row items-center gap-1">
          <span class="font-semibold text-xs text-light-200"> Land </span>
        </div>

        } @else if (property.category === categoryEnum.TRANSPORTATION) {
        <div class="flex flex-row items-center gap-1">
          <span class="font-semibold text-xs text-light-200">
            Transportation
          </span>
        </div>

        } @else if (property.category === categoryEnum.RESIDENTIAL) {
        <div class="flex flex-row items-center gap-1">
          <svg-icon
            [src]="'assets/icons/bed.svg'"
            svgClass="h-4 w-4 text-light-100"
          />
          <span class="font-semibold text-xs text-light-200">
            {{ property.numberOfBedrooms }}
          </span>
        </div>
        }

        <p-divider layout="vertical" />
        <div class="flex flex-row items-center gap-1">
          <i-tabler
            name="number"
            class="custom-svg !text-light-200 !w-4 !h-4"
          ></i-tabler>
          <span class="font-semibold text-xs text-light-200">
            {{ property.propertyNumber }}
          </span>
        </div>

        <p-divider layout="vertical" />
        <div class="flex flex-row items-center gap-1">
          <svg-icon
            [src]="'assets/icons/' + property.state + '.svg'"
            svgClass="h-4 w-4 text-light-100"
          />
          <span class="font-semibold text-xs text-light-200">
            @switch (property.state) {
            <!-- READY -->
            @case (State.READY) { Ready }

            <!-- CONSTRUCTION -->
            @case (State.CONSTRUCTION) { Construction }

            <!-- RENOVATION -->
            @case (State.RENOVATION) { Renovation }

            <!-- OPERATIONAL -->
            @case (State.OPERATIONAL) { Operational }

            <!-- SOLD -->
            @case (State.SOLD) { Sold }

            <!--  -->
            }
          </span>
        </div>

        <p-divider layout="vertical" />
        <div class="flex flex-row items-center gap-1">
          <div class="w-3 h-3 overflow-hidden rounded-full">
            <img
              [src]="
                'assets/flags/' +
                (property?.country?.shortName | lowercase) +
                '.svg'
              "
              class="w-full h-full object-cover"
              alt="Country Flag"
            />
          </div>

          <span class="font-semibold text-xs text-light-200">
            {{ property.country?.shortName }}
          </span>
        </div>
      </div>

      <h2 class="text-lg font-bold mb-2 line-clamp-2">
        {{ property.name }}
      </h2>

      @switch (property.investementStatus) {
      <!-- AVAILABLE -->
      @case (InvestementStatus.AVAILABLE) {
      <div>
        <div class="flex flex-row items-baseline justify-between mb-2">
          <p class="font-extrabold text-xl text-blue-50">
            <span class="text-base">{{ currency }}</span>
            {{ property.price | number }}
          </p>

          <p class="font-medium text-xs text-light-100">
            {{ property.totalInvestedPercentage | number : "1.2-2" }}% funded
          </p>
        </div>

        <p-progressbar
          [style]="{ height: '8px' }"
          [value]="property.totalInvestedPercentage"
          [showValue]="false"
        />
      </div>

      <div
        class="flex flex-col gap-2 py-3 px-2 bg-light-50 rounded-lg text-sm mt-3"
      >
        <div class="flex flex-row justify-between">
          <p class="text-light-100">5 year total return</p>
          <p class="font-bold text-light-300">
            {{ property.totalReturnPercentage | number : "1.2-2" }}%
          </p>
        </div>

        <div class="flex flex-row justify-between">
          <p class="text-light-100">Yearly investment return</p>
          <p class="text-light-300 font-bold">
            {{ property.totalReturnPercentage / 5 | number : "1.2-2" }}%
          </p>
        </div>

        <div class="flex flex-row justify-between">
          <p class="text-light-100">Projected net yield</p>
          <p class="text-light-300 font-bold">
            {{ property.netYieldPercentage | number : "1.2-2" }}%
          </p>
        </div>
      </div>

      }
      <!-- FUNDED -->
      @case (InvestementStatus.FUNDED) {
      <div>
        <div class="flex flex-row items-baseline justify-between mb-2">
          <p class="font-extrabold text-xl text-blue-50">
            <span class="text-base">{{ currency }}</span>
            {{ property.price | number }}
          </p>

          <p class="font-medium text-xs text-light-100">
            <span class="font-bold">{{ property.numberOfInvestors }}</span>
            investors
          </p>
        </div>
      </div>

      <div
        class="flex flex-col gap-2 py-3 px-2 bg-light-50 rounded-lg text-sm mt-3"
      >
        <div class="flex flex-row justify-between">
          <p class="text-light-100">Yearly investment return</p>
          <p class="text-light-300 font-bold">
            {{ property.totalReturnPercentage / 5 | number : "1.2-2" }}%
          </p>
        </div>

        <div class="flex flex-row justify-between">
          <p class="text-light-100">Funded date</p>
          <p class="font-bold text-light-300">
            {{ property.fundedDate | date }}
          </p>
        </div>

        <div class="flex flex-row justify-between">
          <p class="text-light-100">Current valuation</p>
          <p class="text-light-300 font-bold">
            {{ property.latestValuation | customCurrency : currency : "1.0-0" }}
          </p>
        </div>
      </div>

      }
      <!-- EXITED -->
      @case (InvestementStatus.EXITED) {
      <div>
        <div class="flex flex-row items-baseline justify-between mb-2">
          <p class="font-extrabold text-xl text-blue-50">
            <span class="text-base">{{ currency }}</span>
            {{ property.price | number }}
          </p>

          <div class="flex flex-row gap-2 items-center text-light-100">
            <svg-icon src="assets/icons/calendar-exit.svg" svgClass="h-4 w-4" />
            <p class="font-medium text-xs">
              Sold in {{ property.exitDate | date }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-2 py-3 px-2 bg-light-50 rounded-lg text-sm mt-3"
      >
        <div class="flex flex-row justify-between">
          <p class="text-light-100">Funded date</p>
          <p class="font-bold text-light-300">
            {{ property.fundedDate | date }}
          </p>
        </div>

        <div class="flex flex-row justify-between">
          <p class="text-light-100">Purchase price</p>
          <p class="text-light-300 font-bold">
            {{ property.grossSellPrice | customCurrency : currency }}
          </p>
        </div>

        <div class="flex flex-row justify-between">
          <p class="text-light-100">Total rental income</p>
          <p class="text-light-300 font-bold">
            {{
              property.grossTotalRentalIncome
                | customCurrency : currency : "1.0-0"
            }}
          </p>
        </div>
      </div>

      }
      <!--  -->
      @default { Check property.investementStatus -
      {{ property.investementStatus }}
      }
      <!--  -->
      }
    </p-card>
    } @empty {

    <!-- Show loading skeleton  -->
    @if(isLoading){
    <ng-container *ngTemplateOutlet="loadingPropertiesSkeleton" />
    }

    <!--  -->
    }
  </div>

  <!-- Show Properties empty page -->
  @if(!showBookmarkedProperties && !isLoading && properties.length === 0 &&
  appliedFiltersCount === 0){
  <ng-container *ngTemplateOutlet="emptyPropertiesList" />
  }

  <!-- Show Filtered Properties empty page -->
  @if(!showBookmarkedProperties && !isLoading && properties.length === 0 &&
  appliedFiltersCount > 0){
  <ng-container *ngTemplateOutlet="emptyFilteredPropertiesList" />
  }

  <!-- Show BookmarkedProperties empty page -->
  @if(showBookmarkedProperties && !isLoading && properties.length === 0){
  <ng-container *ngTemplateOutlet="emptyBookmarkedPropertiesList" />
  }

  <!--  -->
</div>

<p-dialog
  header="Welcome to Seedio!"
  [modal]="true"
  [(visible)]="showWelcomeDialog"
  [style]="{ width: '512px' }"
  draggable="false"
  resizable="false"
>
  <div class="flex flex-col items-center gap-5">
    <p>
      We're excited to have you on board. Explore
      <span class="text-blue-50">real estate</span> investment opportunities
      built for your goals.
    </p>

    <div class="flex flex-row items-center gap-4 text-light-100">
      <img
        src="assets/images/icons8-error-52.png"
        alt="Seedio Logo"
        class="w-6 h-6"
      />
      <p class="text-sm text-light-200">
        <span>Demo Mode:</span> This version is for demonstration purposes only.
        Data and actions might not be saved.
      </p>
    </div>

    <p-button
      type="submit"
      label="Let's start!"
      size="large"
      (onClick)="showWelcomeDialog = false"
    />
  </div>
</p-dialog>

<ng-template #loadingPropertiesSkeleton>
  @for (_ of (showBookmarkedProperties ? [1, 2, 3] : [1, 2, 3, 4, 5, 6, 7, 8]);
  track $index) {
  <p-card
    [style]="{
      'min-width': '350px',
      'max-width': '390px',
      height: '100%',
      overflow: 'hidden'
    }"
  >
    <ng-template #header>
      <p-skeleton height="232px" borderRadius="0" />
    </ng-template>

    <div class="flex flex-col justify-between gap-5">
      <p-skeleton height="20px" />
      <p-skeleton height="30px" width="70%" />
      <p-skeleton height="18px" />
      <p-skeleton height="100px" />
    </div>
  </p-card>
  }
</ng-template>

<ng-template #emptyPropertiesList>
  <div class="flex flex-col gap-6 w-full h-full items-center justify-center">
    <div
      class="flex flex-col items-center justify-center border-4 border-blue-300 w-24 h-24 rounded-full"
    >
      <svg-icon
        src="assets/icons/home.svg"
        svgClass="h-14 w-14 text-blue-100"
      />
    </div>

    <h1 class="font-bold text-4xl text-light-300">
      Something exciting is coming
    </h1>
    <p class="text-xl text-light-300">
      New properties will be available very soon. Stay tuned!
    </p>
  </div>
</ng-template>

<ng-template #emptyFilteredPropertiesList>
  <div class="flex flex-col gap-6 w-full h-full items-center justify-center">
    <div
      class="flex flex-col items-center justify-center border-4 border-blue-300 w-24 h-24 rounded-full"
    >
      <svg-icon
        src="assets/icons/home.svg"
        svgClass="h-14 w-14 text-blue-100"
      />
    </div>

    <h1 class="font-bold text-4xl text-light-300">
      No matching properties found
    </h1>
    <p class="text-xl text-light-300">Try adjusting your filters!</p>
  </div>
</ng-template>

<ng-template #emptyBookmarkedPropertiesList>
  <div class="flex flex-col gap-6 w-full h-full items-center justify-center">
    <div
      class="flex flex-col items-center justify-center border-4 border-blue-300 w-24 h-24 rounded-full"
    >
      <svg-icon
        src="assets/icons/bookmarks.svg"
        svgClass="h-14 w-14 text-blue-100"
      />
    </div>

    <h1 class="font-bold text-4xl text-light-300">Your list is empty</h1>
    <p class="text-xl text-light-300 text-center">
      Looks like you haven’t added any properties in your bookmarks list
    </p>

    <p-button
      severity="primary"
      type="submit"
      label="View properties"
      size="large"
      (onClick)="onViewProperties()"
    />
  </div>
</ng-template>
